// extracted by mini-css-extract-plugin
export default {"btn":"ClearFiltersButton_btn__8n+vV"};